import { memo, FC } from 'react';
import { useUnit } from 'effector-react';
import { DataGrid } from '@unicorn-shared/interface';
import { setOpenedId } from '@features/tickets/models/detail-sdui-opened-id/model';
import { sortToolbarChangedFunc } from '@features/toolbarSort';
import {
  $tableData,
  $pagination,
  $visibilityColumns,
  open,
  $pinnedColumns,
  $rowCount,
  $sorting,
  $isLoadingList,
  $selectedRows,
  $orderedColumns,
  $resizedColumns,
  setHiddenColumns,
  setPinnedColumns,
  setOrderedColumns,
  setResizedColumns,
  resetOrderedColumns,
  resetResizedColumns,
  setPagination,
} from '../../models';
import { columns } from '../../models/table/columns';
import { CustomToolbar } from '../../molecules';
import { SortFilterToolbar } from './sortFilterToolbar';
import * as Styled from './styled';

export const sortFilterToolbarId = 'tickets-sort';

export const Table: FC = memo(() => {
  const [
    isLoading,
    tableData,
    pagination,
    hiddenColumns,
    rowCount,
    pinnedColumns,
    sorting,
    selectedRows,
    orderedColumns,
    resizedColumns,
  ] = useUnit([
    $isLoadingList,
    $tableData,
    $pagination,
    $visibilityColumns,
    $rowCount,
    $pinnedColumns,
    $sorting,
    $selectedRows,
    $orderedColumns,
    $resizedColumns,
  ]);

  const onRowClick = ({ id }: { id: string }) => {
    const newVersion = localStorage.getItem('ticketsNewVersion') === 'new';

    if (newVersion) {
      setOpenedId(id);
      return;
    }

    open(Number(id));
  };

  return (
    <Styled.Container elevation={0}>
      <CustomToolbar />

      <SortFilterToolbar />

      <DataGrid
        name="tickets"
        rows={tableData}
        columns={columns}
        loading={isLoading}
        onRowClick={onRowClick}
        currentRow={selectedRows[0]}
        rowCount={rowCount}
        externals={{
          pagination,
          setPagination,
          sorting,
          setSorting: (gridSortModel) =>
            sortToolbarChangedFunc({ id: sortFilterToolbarId, gridSortModel }),
          hiddenColumns,
          setHiddenColumns,
          pinnedColumns,
          setPinnedColumns,
          orderedColumns,
          setOrderedColumns,
          resetOrderedColumns,
          resizedColumns,
          setResizedColumns,
          resetResizedColumns,
        }}
      />
    </Styled.Container>
  );
});
